import type { PageDefinition } from '@wix/thunderbolt-becky-types'
import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api'
import { name } from '../symbols'

const wixEmbedsApiPageConfig: PageConfigFn<Record<string, never>> = ({ api }: VsmContext, pageId: string) => {
	const pageData = api.components.getCompData<PageDefinition['data']>(pageId)
	const shouldLoadPageFeature = pageData ? api.page.isRoutablePage(pageData) : false

	if (!shouldLoadPageFeature) {
		return { shouldLoadPageFeature: false }
	}

	return {
		shouldLoadPageFeature: true,
		pageConfig: {},
	}
}

export const pageConfig: PageConfigEntry<Record<string, never>> = {
	name,
	configFactory: wixEmbedsApiPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
